import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import {
  BlankValidator,
  CPFValidator,
  DateValidator,
  MaskManager,
  NbpConfirmComponent,
  NbpInfoComponent,
  UtilHelper,
  ValidationResult,
} from '../../../shared';
import { EnderecoModel } from '../../../shared/endereco/';
import { EnderecoService } from '../../../shared/endereco/endereco.service';
import { NgbdModalContent } from '../../../shared/modal/ngbd-modal-content';
import { EmailValidator } from '../../../shared/validators/emailPattern.validator';
import { InstituicaoService } from '../../instituicao/shared';
import { ConsumidorFormatter, ConsumidorModel } from '../shared/consumidor.model';
import { ConsumidorService } from '../shared/consumidor.service';
import { AnimacaoHelper } from '../../../shared/helpers/animacao-helper';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import * as moment from 'moment';
import { TipoResponsabilidadeRepresentanteLegalService } from '../../../shared/service/tipo-responsabilidade-representante-legal.service';
import { TipoResponsabilidadeRepresentanteLegalModel } from '../../../shared/model/tipo-responsabilidade-representante-legal.model';
import { RepresentanteLegalModel } from '../../representanteLegal/shared/representante-legal.model';
import { LinkResourcesService } from '../shared/link-resources-service';
import { FiltroConsumidorReceitaFederal } from '../../../shared/filter/filtro-consumidor-receita-federal';
import { ConsumidorReceitaFederalService } from '../shared/consumidor-receita-federal-service';
import { debounceTime } from 'rxjs/operators';

interface IValidation {
  [key: string]: boolean;
}

@Component({
  selector: 'app-consumidor-adicional',
  templateUrl: './consumidor-adicional.component.html',
  styleUrls: ['./consumidor-adicional.component.css']
})
export class ConsumidorAdicionalComponent implements OnInit, OnDestroy {

  public msgErro = '';
  public msgErroRepresentanteLegal = '';
  public btnCancelarDisabled = false;
  public btnConcluirDisabled = true;
  public mostrarAlertaParticipacao =  false;

  public showRepresentanteLegal = false;

  dadosAdicionaisForm: FormGroup;
  consumidorModel: ConsumidorModel;

  public maskCEP = MaskManager.CEP;
  public maskDDD = MaskManager.DDD;
  public maskTelefone = MaskManager.telefone;
  public maskCPF = MaskManager.CPF;
  public maskData = MaskManager.DATA;

  public subscriptionEnderecoModelSelecionado: Subscription;
  public subsCep: Subscription;
  public subsCepRepresentanteLegal: Subscription;


  public unsubTiposResponsabilidadesRepresentanteLegalChange: Subscription;
  public tiposResponsabilidadesRepresentanteLegal: TipoResponsabilidadeRepresentanteLegalModel[];

  private nomeRepresentanteLegal: string = "";
  private nomeMaeRepresentanteLegal: string = "";

  @Input() breadcrumbInstituicao = true;

  formErrors = {
    nome: [],
    cep: [],
    dddTelefone: [],
    telefone: [],
    celular: [],
    'emailGroup.emailPrincipal': [],
    'emailGroup.confirmEmailPrincipal': [],
    'senhaGroup.senha': [],
    'senhaGroup.senhaConfirm': [],
    fraseSeguranca: [],
    sigUnidFederacao: [],
    logradouro: [],
    cidade: [],
    errosSelecao: [],
    emailOpcional: [],
    senhaGroup: [],
    emailGroup: [],
    numeroEndereco: [],

    // Representante Legal
    cpfRepresentanteLegal: [],
    nomeRepresentanteLegal: [],
    dataNascimentoRepresentanteLegal: [],
    cepRepresentanteLegal: [],
    dddTelefoneRepresentanteLegal: [],
    telefoneRepresentanteLegal: [],
    celularRepresentanteLegal: [],
    sigUnidFederacaoRepresentanteLegal: [],
    logradouroRepresentanteLegal: [],
    cidadeRepresentanteLegal: [],
    errosSelecaoRepresentanteLegal: [],
    emailOpcionalRepresentanteLegal: [],
    emailGroupRepresentanteLegal: [],
    'emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal': [],
    'emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal': [],
    numeroEnderecoRepresentanteLegal: [],
    tipoResponsabilidadeRepresentanteLegal: [],
    cmbAceitaTermoLGPD: [],

  };

  validationMessages = {
    nome: {
      required: 'O Campo Nome é de preenchimento obrigatório.'
    },
    numeroEndereco: {
      required: 'O Campo Número do Endereço é de preenchimento obrigatório.'
    },
    cep: {
      required: 'O Campo CEP é de preenchimento obrigatório.',
      pattern: 'CEP inválido. Informe um CEP válido.'
    },
    dddTelefone: {
      required: 'O Campo DDD é de preenchimento obrigatório.'
    },
    telefone: {
      required: 'O Campo Tel. Contato é de preenchimento obrigatório.',
      pattern: 'Tel. Contato inválido. Informe um Tel. Contato válido.'
    },
    emailOpcional: {
      pattern: 'Email Opcional inválido. Informe um Email Opcional válido.'
    },
    celular: {
      pattern: 'Tel. Opcional inválido. Informe um Tel. Opcional válido.',
      celularObrigatorio: 'DDD opcional informado Tel. Opcional obrigatório.',
      dddCelularObrigatorio: 'Tel. Opcional informado DDD Opcional obrigatório.'
    },
    'emailGroup.emailPrincipal': {
      required: 'O Campo E-mail Principal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroup.confirmEmailPrincipal': {
      required: 'O Campo Confirmar E-mail Principal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'senhaGroup.senha': {
      required: 'O Campo Senha é de preenchimento obrigatório.',
      minlength: UtilHelper.MsgGenericas.senha_minlength,
      maxlength: UtilHelper.MsgGenericas.senha_maxlength
    },
    'senhaGroup.senhaConfirm': {
      required: 'O Campo Confirmar Senha é de preenchimento obrigatório.',
      minlength: UtilHelper.MsgGenericas.senha_minlength,
      maxlength: UtilHelper.MsgGenericas.senha_maxlength
    },
    fraseSeguranca: {
      required: 'O Campo Frase de Segurança é de preenchimento obrigatório.'
    },
    sigUnidFederacao: {
      required: 'O Campo UF é de preenchimento obrigatório.'
    },
    logradouro: {
      required: 'O Campo Endereço é de preenchimento obrigatório.'
    },
    cidade: {
      required: 'O Campo Município é de preenchimento obrigatório.'
    },
    senhaGroup: {
      senhaNaoConfirmada: UtilHelper.MsgGenericas.senha_naoConfirmada
    },
    emailGroup: {
      emailNaoConfirmado: UtilHelper.MsgGenericas.email_NaoConfirmado
    },
    emailGroupInvalid: UtilHelper.MsgGenericas.email_NaoConfirmado,

    emailGroupRepresentanteLegal: {
      emailNaoConfirmado: UtilHelper.MsgGenericas.email_NaoConfirmado
    },
    emailGroupRepresentanteLegalInvalid: UtilHelper.MsgGenericas.email_NaoConfirmado,

    instituicaoNaoSelecionada: 'Você deve selecionar uma instituição que está cadastrada na Campanha Nota Premiada Bahia.',
    aceiteTermos: 'Você deve concordar com as condições estabelecidas no regulamento da Campanha Nota Premiada Bahia.',

    // Representante Legal
    cpfRepresentanteLegal: {
      required: 'O Campo CPF do Representante Legal é de preenchimento obrigatório.',
      cpfInvalido: 'Informe um CPF válido para o Representante Legal.',
      mesmoCpfConsumidor: 'O CPF do Representante Legal deve ser diferente do Consumidor.'
    },

    dataNascimentoRepresentanteLegal: {
      required: 'O Campo Data de Nascimento do Representante Legal é de preenchimento obrigatório.',
      pattern: 'Informe uma Data de Nascimento válida para o Representante Legal.',
      brazilianDate: 'Data de Nascimento inválida. Informe uma Data de Nascimento válida.',
      dataInvalida: 'O Campo Data de Nascimento não pode ser maior que a data atual',
      dataIgualAtual: 'O Campo Data de Nascimento não pode ser igual a data atual.',
      menorDeIdade: 'O Representante Legal deve posuir mais de 18 anos'
    },

    nomeRepresentanteLegal: {
      required: 'O Campo Nome do Representante Legal é de preenchimento obrigatório.'
    },

    nomeMaeRepresentanteLegal: {
      required: 'O Campo Nome da Mãe do Representante Legal é de preenchimento obrigatório.'
    },

    numeroEnderecoRepresentanteLegal: {
      required: 'O Campo Número do Endereço do Representante Legal é de preenchimento obrigatório.'
    },

    cepRepresentanteLegal: {
      required: 'O Campo CEP do Representante Legal é de preenchimento obrigatório.',
      pattern: 'CEP inválido. Informe um CEP válido.'
    },

    dddTelefoneRepresentanteLegal: {
      required: 'O Campo DDD do Representante Legal é de preenchimento obrigatório.'
    },

    telefoneRepresentanteLegal: {
      required: 'O Campo Tel. Contato do Representante Legal é de preenchimento obrigatório.',
      pattern: 'Tel. Contato do Representante Legal é inválido.'
    },

    celularRepresentanteLegal: {
      pattern: 'Celular do Representante Legal inválido. Informe um Celular.',
      celularObrigatorio: 'Telefone deve ser preenchido quando o DDD for informado.',
      dddCelularObrigatorio: 'DDD deve ser preenchido quando o Telefone for informado.'
    },

    sigUnidFederacaoRepresentanteLegal: {
      required: 'O Campo UF do Representante Legal é de preenchimento obrigatório.'
    },

    logradouroRepresentanteLegal: {
      required: 'O Campo Endereço do Representante Legal é de preenchimento obrigatório.'
    },

    cidadeRepresentanteLegal: {
      required: 'O Campo Município do Representante Legal é de preenchimento obrigatório.'
    },

    tipoResponsabilidadeRepresentanteLegal: {
      required: 'O Campo do Tipo de Responsabilidade do Representante Legal é de preenchimento obrigatório.'
    },

    cmbAceitaTermoLGPD: {
      required: 'O Campo de Aceite/Recusa do Termo LGPD é de preenchimento obrigatório.'
    },
    emailOpcionalRepresentanteLegal: {
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal': {
      required: 'O Campo E-mail Principal do Representante Legal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },
    'emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal': {
      required: 'O Campo Confirmar E-mail Principal do Representante Legal é de preenchimento obrigatório.',
      pattern: UtilHelper.MsgGenericas.email_pattern
    },

  };

  public instituicaoSelecionadaChange: Subscription;
  public tipoResponsabilidadeRepresentanteLegalChange: Subscription;

  public linkTermoLGPD: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly consumidorService: ConsumidorService,
    private readonly enderecoService: EnderecoService,
    private readonly ngbModalService: NgbModal,
    private readonly instituicaoService: InstituicaoService,
    private readonly tipoResponsabilidadeRepresentanteLegalService: TipoResponsabilidadeRepresentanteLegalService,
    private readonly LinkResourcesServices: LinkResourcesService,
    private readonly consumidorReceitaFederalService: ConsumidorReceitaFederalService,
  ) {
    this.consumidorService.mn0030 = '';
  }

  private InicializarForm() {

    this.dadosAdicionaisForm = new FormGroup({
      nome: new FormControl(this.consumidorModel.nome, [Validators.required, BlankValidator.valid.bind(this)]),
      cep: new FormControl(
        this.consumidorModel.cep,
        [Validators.required, BlankValidator.valid.bind(this), this.cepTamanhoValidator.bind(this)],
        [this.validaCepExiste.bind(this)]
      ),
      cidade: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      sigUnidFederacao: new FormControl('', [Validators.required, BlankValidator.valid.bind(this)]),
      logradouro: new FormControl(this.consumidorModel.logradouro, [Validators.required, BlankValidator.valid.bind(this)]),
      bairro: new FormControl(this.consumidorModel.bairro),
      complementoEndereco: new FormControl(this.consumidorModel.complementoEndereco),
      numeroEndereco:  new FormControl(this.consumidorModel.numeroEndereco, [Validators.required, BlankValidator.valid.bind(this)]),
      dddTelefone: new FormControl(this.consumidorModel.dddTelefone, [Validators.required, BlankValidator.valid.bind(this)]),
      telefone: new FormControl(this.consumidorModel.telefone, [
        Validators.required,
        Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/),
        BlankValidator.valid.bind(this)
      ]),
      dddCelular: new FormControl(this.consumidorModel.dddCelular),
      celular: new FormControl(this.consumidorModel.celular, [Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/)]),
      emailGroup: new FormGroup(
        {
          emailPrincipal: new FormControl(this.consumidorModel.emailPrincipal, [Validators.required, EmailValidator.valid.bind(this)]),
          confirmEmailPrincipal: new FormControl('', [Validators.required, EmailValidator.valid.bind(this)])
        },
        this.emailMatchValidator.bind(this)
      ),
      emailOpcional: new FormControl(this.consumidorModel.emailOpcional, EmailValidator.valid.bind(this)),
      senhaGroup: new FormGroup(
        {
          senha: new FormControl(this.consumidorModel.senha, [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(15),
            BlankValidator.valid.bind(this)
          ]),
          senhaConfirm: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(15)])
        },
        this.passwordMatchValidator.bind(this)
      ),
      fraseSeguranca: new FormControl(this.consumidorModel.fraseSeguranca, [Validators.required, BlankValidator.valid.bind(this)]),

      stsAceitaTermos: new FormControl(false),
      cmbAceitaTermoLGPD:  new FormControl('',[Validators.required]),

      // Representante Legal
          nomeRepresentanteLegal: new FormControl({value: '', disabled: true}),
          nomeMaeRepresentanteLegal: new FormControl(''),
          cpfRepresentanteLegal: new FormControl(''),
          dataNascimentoRepresentanteLegal: new FormControl(''),
          tipoResponsabilidadeRepresentanteLegal:  new FormControl({value: '', disabled: true}),

          stsUtilizarMesmoEndereco: new FormControl({value: false, disabled: true}),
          stsUtilizarMesmoTelefone: new FormControl({value: false, disabled: true}),
          stsUtilizarMesmoEmail: new FormControl({value: '', disabled: true}),

          cepRepresentanteLegal: new FormControl({value: '', disabled: true}),
          cidadeRepresentanteLegal: new FormControl(''),
          sigUnidFederacaoRepresentanteLegal: new FormControl(''),
          logradouroRepresentanteLegal: new FormControl({value: '', disabled: true}),
          bairroRepresentanteLegal: new FormControl({value: '', disabled: true}),
          complementoEnderecoRepresentanteLegal: new FormControl({value: '', disabled: true}),
          numeroEnderecoRepresentanteLegal:  new FormControl({value: '', disabled: true}),
          dddTelefoneRepresentanteLegal: new FormControl({value: '', disabled: true}),
          telefoneRepresentanteLegal: new FormControl({value: '', disabled: true}),
          dddCelularRepresentanteLegal: new FormControl({value: '', disabled: true}),
          celularRepresentanteLegal: new FormControl({value: '', disabled: true}),

          emailGroupRepresentanteLegal: new FormGroup(
            {
            emailPrincipalRepresentanteLegal: new FormControl({value: '', disabled: true}),
            confirmEmailPrincipalRepresentanteLegal: new FormControl({value: '', disabled: true})
            },
            this.emailRepresentanteLegalMatchValidator.bind(this)
          )
      // Fim Representante Legal

    });

  }

  private SetarLinkDocumentoLGPD() {

    // O Termo LGPD exibido será difderente quando o consumidor que está sendo cadastrado for menor de 12 anos.
    if (this.showRepresentanteLegal) {
      this.linkTermoLGPD = this.LinkResourcesServices.obterLinkAcessoTermoLGPD('Termo_Consentimento_Menor.pdf');
     } else {
      this.linkTermoLGPD = this.LinkResourcesServices.obterLinkAcessoTermoLGPD('Termo_Consentimento_cidadao.pdf');
     }
  }

  private RealizaApresentacaoRepresentante() {

  // Verificação da regra de negócio para exibir o formulário de Representante Legal
    // O Formulário só será exibido caso o Consumidor possua idade menor do que 12 anos.
    if (moment().diff(this.consumidorModel.dataNascimento, 'years') < 12) {
      this.showRepresentanteLegal = true;

      this.dadosAdicionaisForm.controls['nomeRepresentanteLegal']
      .setValidators([Validators.required, BlankValidator.valid.bind(this)]);

      this.dadosAdicionaisForm.controls['nomeMaeRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);

      //this.dadosAdicionaisForm.controls['nomeRepresentanteLegal'].setValue(this.consumidorModel.nomeMae);
      //this.dadosAdicionaisForm.controls['tipoResponsabilidadeRepresentanteLegal'].setValue(2);

      this.dadosAdicionaisForm.controls['cpfRepresentanteLegal'].setValidators([Validators.required,  CPFValidator.validaCPF.bind(this), this.cpfRepresentanteLegalMatchValidator.bind(this)]);

      this.dadosAdicionaisForm.controls['dataNascimentoRepresentanteLegal'].setValidators([Validators.required, DateValidator.validatorDate.bind(this), this.menorIdadeValidator.bind(this)]);
      this.dadosAdicionaisForm.controls['tipoResponsabilidadeRepresentanteLegal'].setValidators([Validators.required]);

      this.dadosAdicionaisForm.controls['cidadeRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.dadosAdicionaisForm.controls['sigUnidFederacaoRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);
      this.dadosAdicionaisForm.controls['logradouroRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);

      this.dadosAdicionaisForm.controls['numeroEnderecoRepresentanteLegal'].setValidators([Validators.required, BlankValidator.valid.bind(this)]);

      this.dadosAdicionaisForm.controls['dddTelefoneRepresentanteLegal'].setValidators([Validators.required]);
      this.dadosAdicionaisForm.controls['telefoneRepresentanteLegal'].setValidators([Validators.required,Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/),BlankValidator.valid.bind(this)]);

      this.dadosAdicionaisForm.controls['celularRepresentanteLegal'].setValidators([Validators.pattern(/^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/)]);

      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValidators([Validators.required, EmailValidator.valid.bind(this)]);
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValidators([Validators.required, EmailValidator.valid.bind(this)]);

      this.dadosAdicionaisForm.controls['cepRepresentanteLegal']
        .setValidators([Validators.required,
                        BlankValidator.valid.bind(this),
                        this.cepTamanhoValidator.bind(this)]);
   } else {
      this.showRepresentanteLegal = false;
   }

  }

  private DefinirSubscriptions() {

    this.dadosAdicionaisForm.valueChanges.subscribe(data => this.onValueChanged(data));

    // Sobrescrevo no observador que monitora a inclusão de instiuições pelos componentes filhos de consumidor-instituição
    this.consumidorModel.instituicoes = [];
    this.instituicaoSelecionadaChange = this.instituicaoService.instituicoesSelecionadaChange.subscribe(data => {
      this.consumidorModel.instituicoes = data;
      this.formErrors.errosSelecao = [];
    });

    this.subsCep = this.dadosAdicionaisForm.get('cep').valueChanges.subscribe(cep => {
      this.cepCleanValidator(cep);
    });

    this.tiposResponsabilidadesRepresentanteLegal = [];
    this.tipoResponsabilidadeRepresentanteLegalChange = this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(data => {
      this.tiposResponsabilidadesRepresentanteLegal = data;
    });

    this.subsCepRepresentanteLegal = this.dadosAdicionaisForm.get('cepRepresentanteLegal').valueChanges.subscribe(cep => {
      this.cepCleanValidatorRepresentante(cep);
    });
  }

  private cepCleanValidatorRepresentante(cep) {
    if (!cep) {
      this.dadosAdicionaisForm.patchValue({
        cidadeRepresentanteLegal: '',
        sigUnidFederacaoRepresentanteLegal: '',
        logradouroRepresentanteLegal: '',
        bairroRepresentanteLegal: '',
        complementoEnderecoRepresentanteLegal: ''
      });
    }
    return null;
  }
     

  ngOnInit() {

    this.consumidorModel = this.consumidorService.getConsumidorModel();
    this.consumidorModel.representanteLegal = new RepresentanteLegalModel();

    this.InicializarForm();

    this.route.queryParams.subscribe(params => {
      this.dadosAdicionaisForm.get('nome').setValue(params.data);
    })
  
    this.DefinirSubscriptions();

    this.RealizaApresentacaoRepresentante();

    this.SetarLinkDocumentoLGPD();
     
    this.preencherCombos();

    this.validaInformacoesRepresentanteLegal();

  } // Fim onInit

  ontipoResponsabilidadeRepresentanteLegalChange(): void {
    const nomeRepresentante = this.dadosAdicionaisForm.value['nomeRepresentanteLegal'];
    const tipo = this.dadosAdicionaisForm.value['tipoResponsabilidadeRepresentanteLegal'];

    if (tipo !=2 && nomeRepresentante == this.consumidorModel.nomeMae) {
      this.dadosAdicionaisForm.get('nomeRepresentanteLegal').setValue('');
    }
  }

  changeCEP(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('cepRepresentanteLegal').setValue(value);
    }
  }

  changeCidade(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('cidadeRepresentanteLegal').setValue(value);
    }
  }

  changeUF(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('sigUnidFederacaoRepresentanteLegal').setValue(value);
    }
  }

  changeLogradouro(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').setValue(value);
    }
  }

  changeBairro(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('bairroRepresentanteLegal').setValue(value);
    }
  }

  changeComplementoEndereco(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('complementoEnderecoRepresentanteLegal').setValue(value);
    }
  }

  changeTelefone(value: string): void {
    const stsUtilizarMesmoTelefone = this.dadosAdicionaisForm.value['stsUtilizarMesmoTelefone'];
    if (stsUtilizarMesmoTelefone) {
      this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').setValue(value);
    }
  }

  changeDddCelular(value: string): void {

    const stsUtilizarMesmoTelefone = this.dadosAdicionaisForm.value['stsUtilizarMesmoTelefone'];

    if (stsUtilizarMesmoTelefone) {
      this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').setValue(value);
    }
  }

  changeCelular(value: string): void {

    const stsUtilizarMesmoTelefone = this.dadosAdicionaisForm.value['stsUtilizarMesmoTelefone'];

    if (stsUtilizarMesmoTelefone) {
      this.dadosAdicionaisForm.get('celularRepresentanteLegal').setValue(value);
    }
  }


  changeDddTelefone(value: string): void {
    const stsUtilizarMesmoTelefone = this.dadosAdicionaisForm.value['stsUtilizarMesmoTelefone'];
    if (stsUtilizarMesmoTelefone) {
      this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').setValue(value);
    }
  }

  changeNumeroEndereco(value: string): void {
    const stsUtilizarMesmoEndereco = this.dadosAdicionaisForm.value['stsUtilizarMesmoEndereco'];
    if (stsUtilizarMesmoEndereco) {
      this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').setValue(value);
    }
  }

  changeEmailPrincipal(value: string): void {
    const stsUtilizarMesmoEmail = this.dadosAdicionaisForm.value['stsUtilizarMesmoEmail'];
    if (stsUtilizarMesmoEmail) {
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValue(value);
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValue(value);
    }
  }

  checkUtilizarMesmoEndereco(event: any) {

    if (event == 'S') {

      this.dadosAdicionaisForm.get('cepRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('cep').value);
      this.dadosAdicionaisForm.get('cidadeRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('cidade').value);
      this.dadosAdicionaisForm.get('sigUnidFederacaoRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('sigUnidFederacao').value);
      this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('logradouro').value);
      this.dadosAdicionaisForm.get('bairroRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('bairro').value);
      this.dadosAdicionaisForm.get('complementoEnderecoRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('complementoEndereco').value);
      this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('numeroEndereco').value);

      this.consumidorModel.representanteLegal.codigoMunicipioIBGERepresentante = this.consumidorModel.codigoMunicipioIBGE;

      this.enderecoGRoupRepresentanteLegalDisable(true);

    } else {

      this.enderecoGRoupRepresentanteLegalDisable(false);
    }
  }

  private enderecoGRoupRepresentanteLegalDisable(value: boolean) {

    if(value) {

      this.dadosAdicionaisForm.get('cepRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('cidadeRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('sigUnidFederacaoRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('bairroRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('complementoEnderecoRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').disable();

    }else{

      this.dadosAdicionaisForm.get('cepRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('cidadeRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('sigUnidFederacaoRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('bairroRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('complementoEnderecoRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').enable();
    }

  }

  checkUtilizarMesmoTelefone(event: any) {

    if (event == 'S') {

      this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('dddTelefone').value);
      this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('telefone').value);

      this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').disable();

      this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('dddCelular').value);
      this.dadosAdicionaisForm.get('celularRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('celular').value);

      this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('celularRepresentanteLegal').disable();

    } else {

      this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').enable();

      this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('celularRepresentanteLegal').enable();

    }
  }

  checkUtilizarMesmoEmail(event: any) {

    if (event == 'S') {

      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('emailGroup.emailPrincipal').value);
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').setValue(this.dadosAdicionaisForm.get('emailGroup.emailPrincipal').value);

      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').disable();
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').disable();

    } else {

      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').enable();
      this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').enable();

    }
 }

  validaCepExiste(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {

    let cep: string = control.value.toString() || '';

    cep = cep.replace(/\.|\-|\_/g, '');

    const q = new Promise<IValidation>((resolve, reject) => {
      if (cep && cep.length === 8) {
        this.enderecoService.getEnderecoPeloCep(cep).subscribe(
          data => {
            this.dadosAdicionaisForm.patchValue({
              sigUnidFederacao: data.estado,
              cidade: data.cidade,
              logradouro: data.logradouro,
              bairro: data.bairro,
              complemento: data.complemento,
              codigoMunicipioIBGE: data.codigoMunicipioIBGE
            });

            this.consumidorModel.codigoMunicipioIBGE = data.codigoMunicipioIBGE;

            resolve(null);
          },
          error => {
            if (cep) {
              this.formErrors['cep'] = [];
              this.formErrors['cep'].push(this.validationMessages.cep.pattern);
              resolve({ pattern: true });
            } else {
              resolve(null);
            }
          }
        );
      } else {
        resolve(null);
      }
    });
    return q;
  }

  ngOnDestroy() {
    if (this.subscriptionEnderecoModelSelecionado) {
      this.subscriptionEnderecoModelSelecionado.unsubscribe();
    }
    this.subsCep.unsubscribe();
    if (this.instituicaoSelecionadaChange) {
      this.instituicaoSelecionadaChange.unsubscribe();
    }
  }

  cepTamanhoValidator(form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const cep: string = form.value.toString();

      if (cep.search('_') !== -1) {
        return { pattern: true };
      }
    }

    return null;
  }

  private cepCleanValidator(cep) {
    if (!cep) {
      this.dadosAdicionaisForm.patchValue({
        cidade: '',
        sigUnidFederacao: '',
        logradouro: '',
        bairro: '',
        complementoEndereco: ''
      });
    }
    return null;
  }

  public onModalBuscaCEP(): void {
    const modal: NgbModalRef = this.ngbModalService.open(NgbdModalContent, this.getModalOptions());

    this.subscriptionEnderecoModelSelecionado = modal.componentInstance.enderecoModelSelecionado.subscribe((endereco: EnderecoModel) => {
      this.dadosAdicionaisForm.patchValue({
        cep: endereco.cep,
        cidade: endereco.cidade,
        sigUnidFederacao: endereco.estado,
        logradouro: endereco.logradouro,
        bairro: endereco.bairro,
        complemento: endereco.complemento,
        codigoMunicipioIBGE: endereco.codigoMunicipioIBGE
      });
      this.consumidorModel.codigoMunicipioIBGE = endereco.codigoMunicipioIBGE;
    });
  }

  public onModalBuscaCEPRepresentanteLegal(): void {

    const modal: NgbModalRef = this.ngbModalService.open(NgbdModalContent, this.getModalOptions());

    this.subscriptionEnderecoModelSelecionado = modal.componentInstance.enderecoModelSelecionado.subscribe((endereco: EnderecoModel) => {
      this.dadosAdicionaisForm.patchValue({
        cepRepresentanteLegal: endereco.cep,
        cidadeRepresentanteLegal: endereco.cidade,
        sigUnidFederacaoRepresentanteLegal: endereco.estado,
        logradouroRepresentanteLegal: endereco.logradouro,
        bairroRepresentanteLegal: endereco.bairro,
        complementoRepresentanteLegal: endereco.complemento,
        codigoMunicipioIBGERepresentanteLegal: endereco.codigoMunicipioIBGE
      });

      this.consumidorModel.representanteLegal.codigoMunicipioIBGERepresentante = endereco.codigoMunicipioIBGE;
    });
  }

  passwordMatchValidator(g: FormGroup): ValidationResult {
    const valorErro = { senhaNaoConfirmada: true };
    return this.validMatchValidator(g, 'senha', 'senhaConfirm', valorErro);
  }

  emailMatchValidator(g: FormGroup): ValidationResult {
    const campoPrincipal = 'emailPrincipal';
    const valorErro = { emailNaoConfirmado: true };
    return this.validMatchValidator(g, campoPrincipal, 'confirmEmailPrincipal', valorErro);
  }

  emailRepresentanteLegalMatchValidator(g: FormGroup): ValidationResult {
    const campoPrincipal = 'emailPrincipalRepresentanteLegal';
    const valorErro = { emailNaoConfirmado: true };
    return this.validMatchValidator(g, campoPrincipal, 'confirmEmailPrincipalRepresentanteLegal', valorErro);
  }

  validMatchValidator(g: FormGroup, _formControlNamePrincipal: string, _formControlNameConfirm: string, erroReturn: any): ValidationResult {
    if (!g.get(_formControlNamePrincipal).valid || !g.get(_formControlNameConfirm).valid) {
      return null;
    }

    if (!g.get(_formControlNamePrincipal).value && !g.get(_formControlNameConfirm).value) {
      return null;
    }

    if (g.get(_formControlNamePrincipal).value !== g.get(_formControlNameConfirm).value) {
      return erroReturn;
    }

    return null;
  }


  dddEmbbedValidator(controlDDD: AbstractControl, controlCelular: AbstractControl): boolean {
    const undef = undefined;
    const dddCelular = controlDDD.value;
    const celular = controlCelular.value;

    const formGroup = controlDDD.parent.controls;
    const name = Object.keys(formGroup).find(name => controlDDD === formGroup[name]) || null;

    if (name == 'dddCelularRepresentanteLegal') {

      if (dddCelular !== null && dddCelular !== undef && dddCelular !== '') {

        if (!this.dadosAdicionaisForm.getRawValue().celularRepresentanteLegal) {

          this.formErrors.celularRepresentanteLegal.push(this.validationMessages.celularRepresentanteLegal.celularObrigatorio);
          return false;
        } else {
          this.formErrors.celularRepresentanteLegal = [];
        }
      } else {
        this.formErrors.celularRepresentanteLegal = [];
      }

      if (celular !== null && celular !== undef && celular !== '') {

        if (!this.dadosAdicionaisForm.getRawValue().dddCelularRepresentanteLegal) {

          this.formErrors.celularRepresentanteLegal.push(this.validationMessages.celularRepresentanteLegal.dddCelularObrigatorio);
          return false;
        } else {
          this.formErrors.celularRepresentanteLegal = [];
        }
      } else {
        this.formErrors.celularRepresentanteLegal = [];
      }

    } else {

      if (dddCelular !== null && dddCelular !== undef && dddCelular !== '') {

            if (!this.dadosAdicionaisForm.getRawValue().celular) {

              this.formErrors.celular.push(this.validationMessages.celular.celularObrigatorio);
              return false;
            } else {
              this.formErrors.celular = [];
            }
          } else {
            this.formErrors.celular = [];
          }

          if (celular !== null && celular !== undef && celular !== '') {

            if (!this.dadosAdicionaisForm.getRawValue().dddCelular) {

              this.formErrors.celular.push(this.validationMessages.celular.dddCelularObrigatorio);
              return false;
            } else {
              this.formErrors.celular = [];
            }
          } else {
            this.formErrors.celular = [];
          }
    }
    return true;
  }

  private getModalOptions(): NgbModalOptions {
    return {
      size: 'lg'
    };
  }

  validaConfirm(formConsumidor: FormControl): { [s: string]: boolean } {
    return { cpfInvalido: true };
  }

  // Metodo para testar a inclusao de um consumidor
  addConsumidor(): void {

    this.consumidorModel.nome = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.value['nome']);
    this.consumidorModel.cep = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.value['cep']);
    this.consumidorModel.logradouro = this.dadosAdicionaisForm.value['logradouro'];
    this.consumidorModel.bairro = this.dadosAdicionaisForm.value['bairro'];
    this.consumidorModel.numeroEndereco = this.dadosAdicionaisForm.value['numeroEndereco'];
    this.consumidorModel.complementoEndereco = this.dadosAdicionaisForm.value['complementoEndereco'];
    this.consumidorModel.dddTelefone = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.value['dddTelefone']);
    this.consumidorModel.telefone = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.value['telefone']);
    this.consumidorModel.dddCelular = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.value['dddCelular']);
    this.consumidorModel.celular = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.value['celular']);
    this.consumidorModel.emailPrincipal = this.dadosAdicionaisForm.get('emailGroup').value['emailPrincipal'];
    this.consumidorModel.emailOpcional = this.dadosAdicionaisForm.value['emailOpcional'];
    this.consumidorModel.senha = this.dadosAdicionaisForm.get('senhaGroup').value['senha'];
    this.consumidorModel.fraseSeguranca = this.dadosAdicionaisForm.value['fraseSeguranca'];
    this.consumidorModel.stsAutorizaNotificacao = 0;

    this.consumidorModel.situacaoCadastroConsumidorId = 1;
    this.consumidorModel.ConcordaComRegulamento = ConsumidorFormatter.formatStsCheckValue(
      this.dadosAdicionaisForm.value['stsAceitaTermos']
    );

    this.consumidorModel.aceitaTermosLGPD = Number(this.dadosAdicionaisForm.value['cmbAceitaTermoLGPD']);

    if (this.showRepresentanteLegal) {
        // Campos Representante Legal:
      //this.consumidorModel.representanteLegal.nomeRepresentante = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.value['nomeRepresentanteLegal']);
      this.consumidorModel.representanteLegal.nomeRepresentante = ConsumidorFormatter.formataString(this.nomeRepresentanteLegal);
      this.consumidorModel.representanteLegal.nomeMaeRepresentante =  this.dadosAdicionaisForm.value['nomeMaeRepresentanteLegal'];

      this.consumidorModel.representanteLegal.cpfRepresentante = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.value['cpfRepresentanteLegal']);
      this.consumidorModel.representanteLegal.dataNascimentoRepresentante = ConsumidorFormatter.strDate2Date(this.dadosAdicionaisForm.value['dataNascimentoRepresentanteLegal']);
      this.consumidorModel.representanteLegal.codTipoResponsabilidadeRepresentante = this.dadosAdicionaisForm.value['tipoResponsabilidadeRepresentanteLegal'];
      this.consumidorModel.representanteLegal.logradouroRepresentante = this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').value;

      this.consumidorModel.representanteLegal.numeroEnderecoRepresentante = this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').value;

      this.consumidorModel.representanteLegal.complementoEnderecoRepresentante = this.dadosAdicionaisForm.getRawValue().complementoEnderecoRepresentanteLegal;
      this.consumidorModel.representanteLegal.bairroRepresentante = this.dadosAdicionaisForm.getRawValue().bairroRepresentanteLegal;

      this.consumidorModel.representanteLegal.cepRepresentante = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.get('cepRepresentanteLegal').value);

      this.consumidorModel.representanteLegal.dddTelefoneRepresentante = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.getRawValue().dddTelefoneRepresentanteLegal);
      this.consumidorModel.representanteLegal.telefoneRepresentante = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.getRawValue().telefoneRepresentanteLegal);

      this.consumidorModel.representanteLegal.dddCelularRepresentante = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.getRawValue().dddCelularRepresentanteLegal);
      this.consumidorModel.representanteLegal.celularRepresentante = ConsumidorFormatter.formataNumero(this.dadosAdicionaisForm.getRawValue().celularRepresentanteLegal);

      this.consumidorModel.representanteLegal.emailPrincipalRepresentante = this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal').value['emailPrincipalRepresentanteLegal'];
      this.consumidorModel.representanteLegal.emailPrincipalRepresentante = this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal').value['confirmEmailPrincipalRepresentanteLegal']

      // Fim Campos Representante Legal
    } else {
      this.consumidorModel.representanteLegal = null;
    }

    this.consumidorService.setConsumidorModel(this.consumidorModel);
  }

  onSubmit() {
    
    if (this.validaForm()) {

      this.addConsumidor();

      this.msgErro = '';
      this.msgErroRepresentanteLegal = '';
      this.btnCancelarDisabled = true;
      this.consumidorService.postConsumidorDadosAdicionais(this.consumidorModel).subscribe((data: ConsumidorModel) => {
        this.consumidorModel = new ConsumidorModel();
        this.consumidorService.setConsumidorModel(this.consumidorModel);
        const modalRef = this.ngbModalService.open(NbpInfoComponent);
        modalRef.componentInstance.info = data.mensagemRetorno;
        this.router.navigate(['/']);
      },
      error => {

        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;
        this.msgErro = erro.motivo;

        // Move a tela para cima, para que os erros venham a ser apresentados so usuário.
        AnimacaoHelper.ScrollUpTela(100);

        // Habilito o botão novamente para o usuário corrigir os erros gerados!
        this.btnCancelarDisabled = false;

      });
    }
  }

  cancelaCadastro() {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, this.getModalOptions());
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja cancelar o cadastramento?';

    const unsubConfirm = confirmModal.componentInstance.userConfirmChange.subscribe(userConfirm => {
      if (userConfirm) {
        this.dadosAdicionaisForm.reset();
        this.consumidorModel = new ConsumidorModel();
        this.consumidorService.setConsumidorModel(this.consumidorModel);
        this.router.navigate(['consumidor/cadastro_consumidor']);
        unsubConfirm.unsubscribe();
      }
    });
  }

  onValueChanged(data?: any) {
    this.formErrors.errosSelecao = [];
    for (const campo in this.formErrors) {
      const control = this.dadosAdicionaisForm.get(campo);
      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          this.formErrors[campo].push(messages[key]);
        }
      }
    }
  }

  validaForm(): boolean {
    let valid = true;
    this.formErrors.errosSelecao = [];
    for (const campo in this.formErrors) {
      const control = this.dadosAdicionaisForm.get(campo);
      this.formErrors[campo] = [];


      if (control && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          valid = false;
          this.formErrors[campo].push(messages[key]);
        }
      }
    }

    if (this.consumidorModel.instituicoes.length === 0) {
      this.formErrors.errosSelecao.push(this.validationMessages['instituicaoNaoSelecionada']);
      valid = false;
    }

    const stsAceitaTermos = this.dadosAdicionaisForm.value['stsAceitaTermos'];
    if (!stsAceitaTermos) {
      this.formErrors.errosSelecao.push(this.validationMessages['aceiteTermos']);
      valid = false;
    }

    if (!this.dddEmbbedValidator(this.dadosAdicionaisForm.controls['dddCelular'],this.dadosAdicionaisForm.controls['celular'])) {
      valid = false;
    }

    if (this.showRepresentanteLegal) {
      if (!this.dddEmbbedValidator(this.dadosAdicionaisForm.controls['dddCelularRepresentanteLegal'],this.dadosAdicionaisForm.controls['celularRepresentanteLegal'])) {
        valid = false;
      }
    }


    return valid;
  }

  onBuscaCEP() {
    let cep: string = this.dadosAdicionaisForm.value['cep'] || '';

    cep = cep.replace(/\.|\-|\_/g, '');

    if (cep && cep.length === 8) {
      const s: Subscription = this.enderecoService.getEnderecoPeloCep(cep).subscribe(
        (data: EnderecoModel) => {
          this.dadosAdicionaisForm.patchValue({
            sigUnidFederacao: data.estado,
            cidade: data.cidade,
            logradouro: data.logradouro,
            bairro: data.bairro,
            complemento: data.complemento,
            codigoMunicipioIBGE: data.codigoMunicipioIBGE
          });

          this.consumidorModel.codigoMunicipioIBGE = data.codigoMunicipioIBGE;
          s.unsubscribe();
        },
        erro => {
          this.consumidorModel.codigoMunicipioIBGE = 0;

          // Apresenta a mensagem de erro para o usuário.
         let error = erro as StatusRequisicao;

          this.formErrors['cep'] = [];
          this.formErrors['cep'].push(error.motivo);
        }
      );
    } else {
      if (cep) {
        this.formErrors['cep'] = [];
        this.formErrors['cep'].push(this.validationMessages.cep.pattern);
      }
    }
  }

  onBuscaCEPRepresentanteLegal() {

    let cep: string = this.dadosAdicionaisForm.value['cepRepresentanteLegal'] || '';

    cep = cep.replace(/\.|\-|\_/g, '');

    if (cep && cep.length === 8) {
      const s: Subscription = this.enderecoService.getEnderecoPeloCep(cep).subscribe(
        (data: EnderecoModel) => {
          this.dadosAdicionaisForm.patchValue({
            sigUnidFederacaoRepresentanteLegal: data.estado,
            cidadeRepresentanteLegal: data.cidade,
            logradouroRepresentanteLegal: data.logradouro,
            bairroRepresentanteLegal: data.bairro,
            complementoRepresentanteLegal: data.complemento,
            codigoMunicipioIBGERepresentanteLegal: data.codigoMunicipioIBGE
          });

          this.consumidorModel.representanteLegal.codigoMunicipioIBGERepresentante = data.codigoMunicipioIBGE;
          s.unsubscribe();
        },
        erro => {
          this.consumidorModel.representanteLegal.codigoMunicipioIBGERepresentante = 0;

          // Apresenta a mensagem de erro para o usuário.
          let error = erro as StatusRequisicao;

          this.formErrors['cepRepresentanteLegal'] = [];
          this.formErrors['cepRepresentanteLegal'].push(error.motivo);
        }
      );
    } else {
      if (cep) {
        this.formErrors['cep'] = [];
        this.formErrors['cep'].push(this.validationMessages.cep.pattern);
      }
    }
  }

  instituicaoSelected(selecionada: boolean) {
    this.formErrors.errosSelecao = [];
  }

  preencherCombos() {

    this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(
      (responsabilidades: TipoResponsabilidadeRepresentanteLegalModel[]) => {
        this.tiposResponsabilidadesRepresentanteLegal = responsabilidades;
      }
    );

    this.tipoResponsabilidadeRepresentanteLegalService.getTiposResponsabilidadesRepresentanteLegal();

        // Inicio o observador que monitora mudança na lista de areas participacoes
        this.unsubTiposResponsabilidadesRepresentanteLegalChange = this.tipoResponsabilidadeRepresentanteLegalService.tiposResponsabilidadesRepresentanteLegalChange.subscribe(
          (tiposResponsabilidadesRepresentanteLegal: TipoResponsabilidadeRepresentanteLegalModel[]) => {
            try {
              this.tiposResponsabilidadesRepresentanteLegal = tiposResponsabilidadesRepresentanteLegal;
    
            } catch (error) {
              console.log('============ unsubTiposResponsabilidadesRepresentanteLegalChange : ' + error);
            }
          }
        );
    
        this.tipoResponsabilidadeRepresentanteLegalService.getTiposResponsabilidadesRepresentanteLegal();

  }

  onCmbAceitaTermoLGPDChange(event){
    if (event.target.value == '' || event.target.value == '0') {
      this.btnConcluirDisabled = true;
    } else {
      this.btnConcluirDisabled = false;
    }

    if (event.target.value == '0') {
      this.mostrarAlertaParticipacao = true;
    } else {
      this.mostrarAlertaParticipacao = false;
    }
  }

  cpfRepresentanteLegalMatchValidator (form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const cpfRepresentante: number = ConsumidorFormatter.formataNumero(form.value.toString());
      const cpfConsumidor: number = ConsumidorFormatter.formataNumero(this.consumidorModel.cpf);
      if (cpfRepresentante == cpfConsumidor) {
        return { mesmoCpfConsumidor: true };
      }
    }

    return null;
  }

  menorIdadeValidator(form: FormControl): ValidationResult {
    if (form.value !== null && form.value !== undefined && form.value !== '') {
      const data: any = form.value.toString();

      if (moment(data, "DD/MM/YYYY", true).isValid()) {
        if (moment().diff(data, 'years') < 18) {
          return { menorDeIdade: true };
        }
      }
    }

    return null;
  }

  private validaInformacoesRepresentanteLegal(){

    this.dadosAdicionaisForm.get('cpfRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
      if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
        this.validaSituacaoRepresentanteLegalReceitaFederal();
    });

    this.dadosAdicionaisForm.get('dataNascimentoRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
      if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
        this.validaSituacaoRepresentanteLegalReceitaFederal();
    });

    this.dadosAdicionaisForm.get('nomeMaeRepresentanteLegal').valueChanges.pipe(debounceTime(5000)).subscribe(() => {
      if (this.camposObrigatoriosRepresentanteLegalPreenchidos())
        this.validaSituacaoRepresentanteLegalReceitaFederal();
    });

  }

  private camposObrigatoriosRepresentanteLegalPreenchidos(){

    let cpfRepresentanteLegal = this.dadosAdicionaisForm.get('cpfRepresentanteLegal').value;
    let dataNascimentoRepresentanteLegal = this.dadosAdicionaisForm.get('dataNascimentoRepresentanteLegal').value;
    let nomeMaeRepresentanteLegal = this.dadosAdicionaisForm.get('nomeMaeRepresentanteLegal').value;

    return ((cpfRepresentanteLegal !== null && cpfRepresentanteLegal !== undefined && cpfRepresentanteLegal !== '') &&
        (dataNascimentoRepresentanteLegal !== null && dataNascimentoRepresentanteLegal !== undefined && dataNascimentoRepresentanteLegal !== '') &&
        (nomeMaeRepresentanteLegal !== null && nomeMaeRepresentanteLegal !== undefined && nomeMaeRepresentanteLegal !== ''));
  }

  private validaSituacaoRepresentanteLegalReceitaFederal() {

    let cpf = ConsumidorFormatter.formataString(this.dadosAdicionaisForm.get('cpfRepresentanteLegal').value);

    if(cpf != this.consumidorModel.cpf) {
      var filtro = new FiltroConsumidorReceitaFederal(cpf, 
                                                    ConsumidorFormatter.strDateWithoutHourAndSlash(this.dadosAdicionaisForm.get('dataNascimentoRepresentanteLegal').value),
                                                    this.dadosAdicionaisForm.get('nomeMaeRepresentanteLegal').value);

      this.consumidorReceitaFederalService.validaSituacaoConsumidorReceitaFederal(filtro).subscribe((data) => {
        // preencher o nome do representante legal e deixar o campo desabilitado
        this.dadosAdicionaisForm.get('nomeRepresentanteLegal').setValue(data.nomeCidadao);

        this.nomeRepresentanteLegal = data.nomeCidadao;

        // habilitar os outros campos para o representante legal possa preencher
        this.habilitarCamposRepresentanteLegal();
        // limpar mensagem de erro
        if (this.msgErroRepresentanteLegal)
            this.msgErroRepresentanteLegal = '';
        if (this.dadosAdicionaisForm.get('tipoResponsabilidadeRepresentanteLegal').enabled) {
          this.resetRepresentanteLegalFormControls();
        }
      },
      (error: any) => {
        let err = error as StatusRequisicao; 
        this.msgErroRepresentanteLegal = err.motivo;
        this.desabilitarCamposRepresentanteLegal();
        if(this.dadosAdicionaisForm.get('nomeRepresentanteLegal').value)
          this.dadosAdicionaisForm.get('nomeRepresentanteLegal').setValue('');
      });
    } else {
      if (this.msgErroRepresentanteLegal)
          this.msgErroRepresentanteLegal = '';
      this.desabilitarCamposRepresentanteLegal();
      if(this.dadosAdicionaisForm.get('nomeRepresentanteLegal').value)
          this.dadosAdicionaisForm.get('nomeRepresentanteLegal').setValue('');
    }
  }

  private habilitarCamposRepresentanteLegal(){

    this.enderecoGRoupRepresentanteLegalDisable(false);

    this.dadosAdicionaisForm.get('tipoResponsabilidadeRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEndereco').enable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoTelefone').enable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEmail').enable();
    this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('celularRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').enable();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').enable();
  }

  private desabilitarCamposRepresentanteLegal(){

    this.enderecoGRoupRepresentanteLegalDisable(true);

    this.dadosAdicionaisForm.get('tipoResponsabilidadeRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEndereco').disable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoTelefone').disable();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEmail').disable();
    this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('celularRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').disable();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').disable();
  }

  private resetRepresentanteLegalFormControls() {

    this.dadosAdicionaisForm.get('cepRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('cidadeRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('sigUnidFederacaoRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('logradouroRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('bairroRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('complementoEnderecoRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('numeroEnderecoRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('tipoResponsabilidadeRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEndereco').reset();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoTelefone').reset();
    this.dadosAdicionaisForm.get('stsUtilizarMesmoEmail').reset();
    this.dadosAdicionaisForm.get('dddTelefoneRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('telefoneRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('dddCelularRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('celularRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.emailPrincipalRepresentanteLegal').reset();
    this.dadosAdicionaisForm.get('emailGroupRepresentanteLegal.confirmEmailPrincipalRepresentanteLegal').reset();

  }

  LimparErros(event) { 
    this.msgErroRepresentanteLegal = "";
  } 

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-adicional/consumidor-adicional.component.ts